export default __webpack_public_path__ + "static/media/icons8-group-task-100.c685b23e.svg";